<section [ngClass]="dynamicClass">
    <div class="eq-container">
      <form [formGroup]="complaintForm" (ngSubmit)="onSubmit()" class="eq-py-5 eq-flex eq-flex-col lg:eq-grid lg:eq-grid-cols-2 eq-gap-5 lg:eq-gap-x-10 lg:eq-gap-y-6">
        <div app-form-dropdown 
          formControlName="salutation"
          [name]="'salutation'"
          [id]="'salutation'"
          [isRequired]="true"
          [labelText]="rendering.fields?.SalutationLabel?.value"
          [hasPlaceholder]="true"
          [placeholderLabel]="rendering.fields?.DropdownPlaceholder?.value"
          [options]="salutationOptions"
          [error]="isFieldInvalid('salutation')"
          [errorText]="rendering?.fields?.FieldIsRequiredError?.value"
          [sorting]="false"
          class="lg:eq-col-span-2 lg:eq-w-1/2 lg:eq-pr-[20px] xl:eq-pr-[30px]"
        ></div>
        <div 
          app-form-text-input
          formControlName="name"
          [name]="'name'"
          [id]="'name'"
          [labelText]="rendering.fields?.NameLabel?.value"
          [isRequired]="true"
          [error]="isFieldInvalid('name')"
          [errorText]="complaintForm.get('name').errors?.minlength ? rendering?.fields?.Min3LengthError?.value : 
            complaintForm.get('name').errors?.maxlength ? rendering?.fields?.MaxLengthError?.value : 
            complaintForm.get('name').errors?.alphabeticOnly ? rendering?.fields?.OnlyAlphabeticError?.value : 
            rendering?.fields?.FieldIsRequiredError?.value"
          class="lg:eq-col-span-1"
        ></div>
        <div 
          app-form-text-input
          formControlName="surname"
          [name]="'surname'"
          [id]="'surname'"
          [labelText]="rendering.fields?.SurnameLabel?.value"
          [isRequired]="true"
          [error]="isFieldInvalid('surname')"
          [errorText]="complaintForm.get('surname').errors?.minlength ? rendering?.fields?.Min3LengthError?.value : 
            complaintForm.get('surname').errors?.maxlength ? rendering?.fields?.MaxLengthError?.value : 
            complaintForm.get('surname').errors?.alphabeticOnly ? rendering?.fields?.OnlyAlphabeticError?.value : 
            rendering?.fields?.FieldIsRequiredError?.value"
          class="lg:eq-col-span-1"
        ></div>
        <div app-form-dropdown 
          formControlName="status"
          [name]="'status'"
          [id]="'status'"
          [isRequired]="true"
          [labelText]="rendering.fields?.StatusLabel?.value"
          [hasPlaceholder]="true"
          [placeholderLabel]="rendering.fields?.DropdownPlaceholder?.value"
          [options]="statusOptions"
          [error]="isFieldInvalid('salutation')"
          [errorText]="rendering?.fields?.FieldIsRequiredError?.value"
          [sorting]="false"
          class="lg:eq-col-span-1"
        ></div>
        <div app-form-dropdown 
          formControlName="isCustomer"
          [name]="'isCustomer'"
          [id]="'isCustomer'"
          [isRequired]="true"
          [labelText]="rendering.fields?.IsCustomerLabel?.value"
          [hasPlaceholder]="true"
          [placeholderLabel]="rendering.fields?.DropdownPlaceholder?.value"
          [options]="isCustomerOptions"
          [error]="isFieldInvalid('isCustomer')"
          [errorText]="rendering?.fields?.FieldIsRequiredError?.value"
          [sorting]="false"
          class="lg:eq-col-span-1"
          (change)="changeIsCustomer()"
        ></div>
        <div 
          app-form-text-input
          formControlName="oasis"
          [name]="'oasis'"
          [id]="'oasis'"
          [labelText]="rendering.fields?.OasisCodeLabel?.value"
          [isRequired]="true"
          [error]="isFieldInvalid('oasis')"
          [errorText]="complaintForm.get('oasis').errors?.minlength ? rendering?.fields?.Min3LengthError?.value : 
            complaintForm.get('oasis').errors?.maxlength ? rendering?.fields?.MaxLengthError?.value : 
            rendering?.fields?.FieldIsRequiredError?.value"
          class="lg:eq-col-start-2 lg:eq-col-end-2"
        ></div>
        <h3 class="eq-text-heading5-m lg:eq-text-heading5 eq-text-blue-darkBlue eq-font-bold eq-mt-7 eq-mb-5 lg:eq-mt-8 lg:eq-mb-6 lg:eq-col-span-2">{{rendering?.fields?.SectionTopicTitle?.value}}</h3>
        <div 
          app-form-text-input
          formControlName="topic"
          [name]="'topic'"
          [id]="'topic'"
          [labelText]="rendering.fields?.TopicLabel?.value"
          [isRequired]="true"
          [error]="isFieldInvalid('topic')"
          [errorText]="complaintForm.get('topic').errors?.minlength ? rendering?.fields?.Min3LengthError?.value : 
          complaintForm.get('topic').errors?.alphabeticOnly ? rendering?.fields?.OnlyAlphabeticError?.value : 
          rendering?.fields?.FieldIsRequiredError?.value"
          class="lg:eq-col-span-2"
        ></div>
        <div 
          app-form-text-area
          formControlName="message"
          [name]="'message'"
          [id]="'message'"
          [helperText]="rendering?.fields?.MessageHelperText?.value"
          [labelText]="rendering.fields?.MessageLabel?.value"
          [maxLength]="+rendering?.fields?.MessageCharLength?.value>0 ? 500 : 500"
          [placeholder]="rendering.fields?.MessagePlaceholder?.value"
          [isRequired]="true"
          [error]="isFieldInvalid('message')"
          [errorText]="complaintForm.get('message').errors?.alphabeticOnly ? rendering?.fields?.OnlyAlphabeticError?.value : rendering?.fields?.FieldIsRequiredError?.value"
          class="eq-h-full lg:eq-h-[86%] lg:eq-col-span-2"
        ></div>
        <h3 class="eq-text-heading5-m lg:eq-text-heading5 eq-text-blue-darkBlue eq-font-bold eq-mt-7 eq-mb-5 lg:eq-mt-8 lg:eq-mb-6 lg:eq-col-span-2">{{rendering?.fields?.SectionContactTitle?.value}}</h3>
        <div app-form-dropdown 
          formControlName="wayofcontact"
          [name]="'wayofcontact'"
          [id]="'wayofcontact'"
          [isRequired]="true"
          [labelText]="rendering.fields?.HowToContactLabel?.value"
          [hasPlaceholder]="true"
          [placeholderLabel]="rendering.fields?.DropdownPlaceholder?.value"
          [options]="howToContactOptions"
          [error]="isFieldInvalid('wayofcontact')"
          [errorText]="rendering?.fields?.FieldIsRequiredError?.value"
          [sorting]="false"
          (change)="changeContactWay()"
          class="lg:eq-col-span-2 lg:eq-w-1/2 lg:eq-pr-[30px]"
        ></div>
        <div 
          app-form-text-input
          formControlName="email"
          [name]="'email'"
          [id]="'email'"
          [labelText]="rendering.fields?.EmailLabel?.value"
          [isRequired]="true"
          [error]="isFieldInvalid('email')"
          [errorText]="complaintForm.get('email').errors?.email ? rendering?.fields?.EmailError?.value : rendering?.fields?.FieldIsRequiredError?.value"
        ></div>
        <div 
          app-form-text-input
          formControlName="telephone"
          [name]="'telephone'"
          [id]="'telephone'"
          [labelText]="rendering.fields?.TelephoneLabel?.value"
          [isRequired]="true"
          [error]="isFieldInvalid('telephone')"
          [mask]="{ mask: '+00 0000000000' }"
          [errorText]="rendering?.fields?.FieldIsRequiredError?.value"
        ></div>
        <div class="lg:eq-col-start-2 lg:eq-col-end-2">
          <div class="eq-text-body-sm-m lg:eq-text-body-sm  eq-mb-4 eq-font-bold" [ngClass]="this.complaintForm.get('timeslot').enabled ? 'eq-text-blue-darkBlue' : 'eq-text-black-natural-60'">{{rendering?.fields?.WhenToContactLabel?.value}}</div>
          <div class="eq-grid lg:eq-grid-cols-3 eq-gap-2 eq-items-center">
            <div app-form-checkbox *ngFor="let item of rendering?.fields?.WhenToContactOptions; let i = index;"
              [name]="'timeslot'" 
              formControlName="timeslot"  
              [isRequired]="false"
              [error]="isFieldInvalid('timeslot')"  
              [id]="'timeslot'+i"
              [labelTextRight]="item.fields?.Text?.value"
              [isChecked]="this.complaintForm.get('timeslot')?.value===item.fields?.Value?.value"
              (change)="changeTimeslot(i)"
            ></div>
          </div>
        </div>
        <div class="eq-flex eq-items-center lg:eq-justify-center lg:eq-col-span-2 lg:eq-mx-auto lg:eq-w-[523px]">
          <div app-form-checkbox 
            formControlName="termsCheckbox"  
            [isRequired]="true"
            [name]="'termsCheckbox'" 
            [id]="'termsCheckbox'"
            [error]="isFieldInvalid('termsCheckbox')"
            [errorText]="rendering?.fields?.TermsAndConditionsError?.value"
            [isChecked]="complaintForm.get('termsCheckbox').value"
            [labelRichText]="rendering.fields.TermsRichText"
          ></div>
        </div>
        <div class="lg:eq-col-span-2 eq-flex eq-flex-col-reverse eq-gap-5 lg:eq-flex-row lg:eq-justify-center lg:eq-items-center lg:eq-gap-[60px]">
          <button (click)="clearForm()" type="button" class="eq-btn eq-btn-secondary">{{rendering.fields?.ClearButtonLabel?.value}}</button>
          <button type="submit" class="eq-btn eq-btn-primary" [disabled]="loading">{{rendering.fields?.SubmitButtonLabel?.value}} <i *ngIf="loading" class="eq-icons eq-icon-hourglass eq-animate-spin eq-ml-2"></i></button>
        </div>
      </form>
    </div>
    <div id="complaintSumbitMessage">
      <div *ngIf="submissionResponse==='success'" class="eq-container md:eq-w-[710px] eq-p-6 eq-bg-white eq-animate-pulse" >
        <div class="eq-text-heading6-m lg:eq-text-heading6 eq-font-bold eq-mb-6 eq-text-blue-darkBlue">{{rendering?.fields?.SuccessTitle?.value}}</div>
        <p>{{rendering?.fields?.SuccessSubtitle?.value}}</p>
      </div>
      <div *ngIf="submissionResponse==='fail'" class="eq-container md:eq-w-[710px] eq-p-6 eq-bg-white eq-animate-pulse">
        <div class="eq-text-heading6-m lg:eq-text-heading6 eq-font-bold eq-mb-6 eq-text-red-brandRed">{{rendering?.fields?.ErrorTitle?.value}}</div>
        <p>{{rendering?.fields?.ErrorSubtitle?.value}}</p>
      </div>
    </div>
</section>
